import { compose } from 'recompose';
import { connect } from 'react-redux';
import { unreadMessages } from 'reducers/announcements/selectors';
import { addProps } from 'utils/recompose';
import combineSelectors from 'utils/combineSelectors';
import srcAlertIcon from './alert-icon.svg';
import newAlertIcon from './icon-notifications.svg';

const mapStateToProps = combineSelectors({
  unreadMessages,
});

export const alertIcon = ({ unreadMessages }) => {
  return unreadMessages && unreadMessages.length > 0
    ? newAlertIcon
    : srcAlertIcon;
};

export default compose(connect(mapStateToProps), addProps({ alertIcon }));
